import { Component, Input, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';

import { Partitioning } from '@classes/partitioning';
import { SimulationVisibilityType } from '@enums/simulation-visibility-type.enum';
import { SimulationService } from '@services/simulation.service';
import { UiService } from '@services/ui.service';
import { SimulationInfo } from '@classes/simulation/simulation-info';

@Component({
    selector: 'app-partitioning-list',
    templateUrl: './partitioning-list.component.html',
    styleUrls: ['./partitioning-list.component.scss']
})
export class PartitioningListComponent implements OnInit, OnChanges, OnDestroy {
    @Input() partitioningsList: Partitioning[];
    @Input() visibility: SimulationVisibilityType;
    @Input() isMJP: boolean;

    private selectedSimuSub: Subscription;
    private loadingStateSub: Subscription;

    visibilityType = SimulationVisibilityType;
    selectedCode: string;
    isLoading: boolean;
    filteredList: Partitioning[];

    constructor(
        private simulationSrv: SimulationService,
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.selectedCode = this.simulationSrv.selectedCode;
        this.filterList();
        this.initSubscriptions();
    }

    ngOnChanges() {
        this.filterList();
    }

    containSelectedCode(simulations: SimulationInfo[]): boolean {
        if(!simulations || !simulations.length) {
            return false;
        }

        return simulations.some(simu => simu.code === this.selectedCode);
    }

    private filterList(): void {
        if(this.partitioningsList) {
            this.filteredList = JSON.parse(JSON.stringify(this.partitioningsList));
            this.filteredList = this.filteredList.map(p => {
                if(p.simulations) {
                    p.simulations = p.simulations.filter(simu => simu.visibility === this.visibility);
                }

                return p;
            });
        }
    }

    private initSubscriptions(): void {
        // To update selected in different lists
        this.selectedSimuSub = this.simulationSrv.selectedSimulationChanged
        .subscribe(selectedSimu => {
            if(selectedSimu) {
                this.selectedCode = selectedSimu.code;
            }
        });

        this.loadingStateSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    ngOnDestroy() {
        if(this.selectedSimuSub) {
            this.selectedSimuSub.unsubscribe();
        }
        if(this.loadingStateSub) {
            this.loadingStateSub.unsubscribe();
        }
    }
}
